import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { environment } from '@environment';
import { ConfigService } from '../../config.service';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { User } from '../../../_models';
import { Collaborator } from '../../../_models/incident/wfdssCase/collaborator';
import { UserIncident, WfdssCase } from '../../../_models/incident/wfdssCase/wfdssCase';
import { AuthenticationService } from '../../user/authentication/authentication.service';
import { ICaseAdvancedSearchParams, ICaseAdvancedSearchFilters } from 'src/app/_components/reports/wfdss-case-search-report/wfdss-case-search-report.component';
import { EInterceptorOptionsHTTPHeaders } from 'src/app/_helpers/interceptors/EInterceptorOptionsHTTPHeaders';
import { Utilities } from 'src/app/_helpers/utility/utilities';

@Injectable({
  providedIn: 'root'
})
export class CaseSearchService {
  private searchResultsSubject: BehaviorSubject<WfdssCase[]>;
  public searchResults: Observable<WfdssCase[]>;
  private readonly baseUrl = this.environment.caseApi.baseUrl;
  private readonly caseByName = this.baseUrl + this.environment.caseApi.caseByName;

  constructor(private http: HttpClient,
    private authService: AuthenticationService,
    private environment: ConfigService) {
    this.searchResultsSubject = new BehaviorSubject<WfdssCase[]>([]);
    this.searchResults = this.searchResultsSubject.asObservable();
  }

  public get searchResultsValue(): WfdssCase[] {
    return this.searchResultsSubject.value;
  }


  getCasesByUserId(watcher: boolean) {
    const relativeUrl = watcher?'/caseSnapshotsByWatcherUserId':'/caseSnapshotsByCollaboratorUserId';
    return this.http.get<UserIncident[]>( this.baseUrl + relativeUrl, {params: {userId: `${this.authService.currentUser.userId}`, limit: "200000"}});
  }

  /**
   * Submit the most current calculated perimeter acreage to the backend
   * @param caseId - wfdssCaseId for the perimeter
   * @param acres - the acreage to save
   * @returns - the entire WfdssCase
   */
  updateCalculatedAcres(caseId: number, acres: number){
    const params = acres !== null && acres >= 0 ? {caseId: caseId, currentCalculatedAcres: acres} : {caseId: caseId}; 
    return this.http.get<WfdssCase>(this.baseUrl + "/cases/" + caseId + "/currentCalculatedAcres", {params: params})
    .pipe(map(wfdssCase => {
      return wfdssCase;
    }))
  }

  getCaseByCaseId(caseId: number){
      return this.http.get<WfdssCase>(this.baseUrl + "/cases/" + caseId ).pipe(
        map((wfdssCase)=>{
          if(wfdssCase.collaborators == null){
            wfdssCase.collaborators = []
          }
        })
      )
  }
/**
 * 
 * @param filter WfdssCases are filtered by the critera in this object. See swagger for implementation details
 * @param pageAndSortParams Server side pagination/sorting params
 * @param suppressSaved Whether to suppress the 'saved' interceptor
 * @returns 
 */
  getCasesByAdvancedSearch(filter: ICaseAdvancedSearchFilters, pageAndSortParams: ICaseAdvancedSearchParams, suppressSaved?: boolean){
    let params = new HttpParams();
    let headers = null
    params = params.append("offset", pageAndSortParams.offset);
    params = params.append("limit", pageAndSortParams.limit)
    params = params.append("sortDirection", pageAndSortParams.sortDirection)
    params = params.append("sortOnField", pageAndSortParams.sortOnField)
    if(suppressSaved){
      headers = Utilities.appendHTTPHeaderForInterceptor([EInterceptorOptionsHTTPHeaders.SupressSavedInterceptor])
    }
    // return type is WfdssCaseSearchDTO, but it's nested in a spring "pagable" interface and making a type for that is nonsense
    return this.http.post<any>(this.baseUrl+'/casesByAdvancedSearch', filter, {params: params, headers: headers})
  }

  getStatesList(){
    return this.http.get<any>(this.baseUrl+'/getStates')
  }

  getCaseSnapshotsByWfdssCaseId(caseId: number){
    const relativeUrl = "/caseSnapshotsByCaseId";
    return this.http.get<UserIncident[]>( this.baseUrl + relativeUrl, {params: {caseId: `${caseId}`}});
  }
}
